import { useParams } from 'react-router';
import { useInfinitySessionHistory } from './hooks/useInfinitySessionHistory';
import { SessionHistoryTable } from 'common/components/SessionHistory/SessionHistoryTable';

const COLUMNS_COUNT = 15;

export const SessionHistoryTableWithInterims = () => {
  const { iccid } = useParams();
  const { sessionHistory, showLoader, refToLoader, fetchingEnded, isLoading } =
    useInfinitySessionHistory(iccid);

  return (
    <SessionHistoryTable
      columnsCount={COLUMNS_COUNT}
      sessionHistory={sessionHistory}
      showProfile={false}
      showLoader={showLoader}
      refToLoader={refToLoader}
      fetchingEnded={fetchingEnded}
      isLoading={isLoading}
    />
  );
};
